import * as React from 'react';
import type { JustifyRestrictionEventPayload as Payload } from 'contracts/restricted-products/restricted-products';
import { api, handleApiError, formDataBuilder } from 'services/api';

export const useJustifyRestrictionEvent = () => {
  const justifyEvent = React.useCallback(async (payload: Payload) => {
    try {
      const formData = formDataBuilder(payload);
      const url = `/restricted-materials/events/justification`;
      await api.post(url, formData);
    } catch (error) {
      throw handleApiError(error);
    }
  }, []);

  return { justifyEvent };
};